<template>
  <div id="OrganizationFulfillment">
    <div class="vx-col w-full mb-base">
      <vx-card collapse-action
               title="Shipping Rates"
               title-color="primary"
               subtitle="Configure shipping rates to show in buyer form">

        <div class="vx-row mb-6 w-2/3">
          <div class="vx-col w-2/5">
            <vs-button color="success" type="filled" @click="addShippingRate">Add Shipping Rate</vs-button>
          </div>
        </div>

        <vs-table :data="shippingRates">

          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Zone</vs-th>
            <vs-th>Type</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in shippingRates">

              <vs-td :data="tr.name">
                {{ tr.name }}
              </vs-td>

              <vs-td :data="tr.zone_id">
                {{ getZoneName(tr.zone_id) }}
              </vs-td>

              <vs-td :data="tr.shipping_rate_type">
                {{ getRateLabel(tr.shipping_rate_type) }}
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-4" @click.stop="editShippingRate(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-4" @click.stop="deleteShippingRate(tr)" />
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>

      </vx-card>
    </div>

    <template>
      <vs-popup title="Shipping Rate" :active.sync="popupNewShippingRate">

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Name</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <vs-input class="w-full" v-model="new_rate.name" name="name" />
            <span class="text-danger text-sm float-left" v-if="!validName">Rate name is required</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Type</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <v-select label="name" :options="rateTypes" name="shipping_rate_type" v-model="new_rate.shipping_rate_type" v-validate="'required'"/>
            <span class="text-danger text-sm float-left" v-if="!validRateType">Shipping Rate Type is required</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Zone</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <v-select label="name" :options="availableZones" name="zone_id" v-model="new_rate.zone_id" v-validate="'required'" />
            <span class="text-danger text-sm float-left" v-if="!validZone">Zone is required</span>
          </div>
        </div>

        <div id="popupTable" class="vx-row mb-6 w-full">
          <vs-table :data="new_rate.shipping_rate_setting" class="w-full ml-6 ">

            <template slot="thead">
              <vs-th>Currency</vs-th>
              <vs-th>Price</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in new_rate.shipping_rate_setting">
                <vs-td :data="tr.currency">
                  {{ tr.currency }}
                </vs-td>

                <vs-td :data="tr.price">
                  {{ tr.price }}
                </vs-td>

                <vs-td class="whitespace-no-wrap">
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteRateSetting(indextr)" />
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>
                  <v-select :options="currencies" auto v-model="new_rate_currency"/>
                  <span class="text-danger text-sm float-left" v-if="!validCurrency">Currency is required</span>
                </vs-td>

                <vs-td>
                  <vs-input class="w-full" v-model="new_rate_price" v-validate="'required'"/>
                  <span class="text-danger text-sm float-left" v-if="!validPrice">Price should be numeric</span>
                </vs-td>

                <vs-td class="whitespace-no-wrap">
                  <feather-icon icon="PlusSquareIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="addRateSetting()" />
                </vs-td>
              </vs-tr>

            </template>
          </vs-table>
        </div>

        <div class="vx-col w-full mb-base">
          <div class="vx-row mb-0">
            <div class="vx-col sm:w-1/3 w-full">
              <span>&nbsp;</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <div class="vx-col ml-auto mr-auto">
                <vs-button class="mr-3 mb-2" size="large" @click.stop="saveNewShippingRate">Save</vs-button>
                <vs-button color="warning" type="border" class="mr-3 mb-2" size="large" @click.stop="closePopup">Cancel</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-popup>
    </template>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import location from '@/services/locationService';


const notifs = {
  error: (msg) => {
    return {
      title: 'Error',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'danger'
    }
  },

  success: (msg) => {
    return {
      title: 'Success',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-check-circle',
      color: 'success'
    }
  }
}

export default {
  components: {
    'v-select': vSelect,
  },

  data () {
    return {
      new_rate: this.getBlankRate(),
      popupNewShippingRate: false,
      new_rate_price: 0,
      new_rate_currency: "RM",
      currencies: ['RM', '$', 'S$', 'THB', 'RP'],
    }
  },

  methods: {

    getZoneName(zone_id) {
      try {
        let zone = this.availableZones.find(x => x.id == zone_id);
        return zone.name;
      } catch (e) {
        console.log(e);
        return "Invalid Zone";
      }
    },

    getRateType(type_id) {
      try {
        let itm = this.rateTypes.find(x => x.type_id == type_id);
        if (typeof itm.name !== 'undefined') {
          return itm;
        }

        return {
          type_id: -99,
          name: 'Invalid type'
        }
      } catch (e) {
        return {
          type_id: -99,
          name: 'Invalid type'
        }
      }
    },

    getRateLabel(type_id) {
      try {
        let itm = this.rateTypes.find(x => x.type_id == type_id);
        if (typeof itm.name !== 'undefined') {
          return itm.name;
        }
      } catch (e) {
        return 'Invalid type'
      }
    },

    getBlankRate() {
      return {
        id: 0,
        name: '',
        zone_id: 0,
        shipping_rate_type: 0,
        organization_id: this.$store.state.user.current_organization,
        shipping_rate_setting: []
      }
    },

    addShippingRate() {
      this.new_rate = this.getBlankRate();
      this.popupNewShippingRate = true;
    },

    editShippingRate(tr) {
      this.new_rate = _.cloneDeep(tr);
      this.new_rate.zone_id = this.availableZones.find(x => x.id == tr.zone_id);
      this.new_rate.shipping_rate_type = this.getRateType(tr.shipping_rate_type);
      this.popupNewShippingRate = true;
    },

    async saveNewShippingRate() {
      // only proceed when valid
      if (!this.validName || !this.validRateType || !this.validZone ) {
        this.$vs.notify(notifs.error("Please complete required fields."))
        return;
      }

      if (!this.validShippingRateSetting) {
        this.$vs.notify(notifs.error("Pleas add rate, make sure you click [+] button."))
        return;
      }

      // convert from object and string to integer

      let rate = _.cloneDeep(this.new_rate);
      if (rate.shipping_rate_setting.length === 0) {
        this.$vs.notify(notifs.error("You need to "))
        return;
      }

      rate.zone_id = rate.zone_id.id;
      rate.shipping_rate_type = rate.shipping_rate_type.type_id;

      try {
        if (rate.id != 0) { // update request
          await this.$store.dispatch('shipping_rate/updateOrganizationShippingRate', {
            rate: rate,
            organization_id: this.$store.state.user.current_organization,
          });
        } else {
          await this.$store.dispatch('shipping_rate/createOrganizationShippingRate', {
            rate: rate,
            organization_id: this.$store.state.user.current_organization,
          });
        }
        this.$vs.notify(notifs.success("Rate successfully saved."));
      } catch(e) {
        this.$vs.notify(notifs.error("Cannot save rate."));
      }

      this.popupNewShippingRate = false;
      this.new_rate = this.getBlankRate();
    },

    async deleteShippingRate(rate) {
      try {
        await this.$store.dispatch('shipping_rate/deleteOrganizationShippingRate', {
          rate: rate,
          organization_id: this.$store.state.user.current_organization,
        });
        this.$vs.notify(notifs.success("Shipping rate deleted"));
      } catch(e) {
        this.$vs.notify(notifs.error("Cannot delete rate shipping"));
      }
    },

    deleteRateSetting(idx) {
      this.new_rate.shipping_rate_setting = this.new_rate.shipping_rate_setting.filter((x, i) => i !== idx);
    },

    closePopup() {
      this.popupNewShippingRate = false;
    },

    addRateSetting() {
      if (!this.validCurrency || !this.validPrice) {
        this.$vs.notify(notifs.error("Please complete the required fields"));
        return; 
      }
      this.new_rate.shipping_rate_setting.push({
        'currency': this.new_rate_currency,
        'price': this.new_rate_price,
      });

      this.new_rate_currency = "RM";
      this.new_rate_price = 0;
    },

  },

  computed: {

    availableZones() {
      let zones = _.cloneDeep(this.$store.state.shipping_rate.zones);
      return zones.map((x) => { return { id: x.id, name: x.name } });
    },

    shippingRates() {
      return this.$store.state.shipping_rate.shipping_rates;
    },

    rateTypes() {
      return this.$store.state.shipping_rate.types;
    },

    validName() {
      return this.new_rate.name != '';
    },

    validRateType() {
      return this.new_rate.shipping_rate_type !== 0;
    },

    validZone() {
      return this.new_rate.zone_id !== 0;
    },

    validShippingRateSetting() {
      return this.new_rate.shipping_rate_setting.length > 0;
    },

    validCurrency() {
      return this.new_rate_currency.trim() !== '';
    },

    validPrice() {
      let price = parseFloat(this.new_rate_price);
      return !isNaN(price);
    },

  },

  async mounted () {
    let result = await Promise.all([
      this.$store.dispatch('shipping_rate/getAvailableZones', this.$store.state.user.current_organization),
      this.$store.dispatch('shipping_rate/getOrganizationShippingRates', this.$store.state.user.current_organization),
    ]).then((res)=> {
    }).catch((e) => {
        console.log(e);
    });
  }
}
</script>

<style lang="scss">
#OrganizationFulfillment {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.con-vs-popup .vs-popup {
  width: 600px !important;
}

#popupTable {
  overflow: scroll;
  overflow-x: hidden;
  height: 10em;

  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */
}

#popupTable::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}

</style>

